// extracted by mini-css-extract-plugin
export default {"ourClientSection":"OurClients_ourClientSection__lEPwW","headingRow":"OurClients_headingRow__UtOiV","heading":"OurClients_heading__+YJio"};